import { render, staticRenderFns } from "./DeleteStaffDialog.vue?vue&type=template&id=d62ba9a4&scoped=true&"
import script from "./DeleteStaffDialog.vue?vue&type=script&lang=js&"
export * from "./DeleteStaffDialog.vue?vue&type=script&lang=js&"
import style0 from "./DeleteStaffDialog.vue?vue&type=style&index=0&id=d62ba9a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d62ba9a4",
  null
  
)

component.options.__file = "DeleteStaffDialog.vue"
export default component.exports